import { Button } from 'flowbite-react';
import React from 'react';
import SEO from '../components/SEO';
import { FaBullhorn, FaCalculator, FaDollarSign, FaRocket, FaUsers } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import SubNav from '../components/subNav';
import { baseUrl } from '../config';



const AdvertisingPromotions = () => {
  const navigate=useNavigate();
  function handleDigital(){
    navigate('/digital');
  }
  function handleInfluencer(){
    navigate('/influencers');
  }
  function handlePaid(){
    navigate('/paid');
  }
  function handleCalculator(){
    navigate('/roi');
  }
  function handleEvent(){
    navigate('/events');
  }
  return (
    <>
    <SEO
      title="Advertisement Promotions"
      description="Create and manage film advertisement campaigns and promotional materials with ProducerBuddy's promotions tools."
      url="https://producerbuddy.pilomation.com/advertisement-promotions"
      robots="noindex, nofollow"
    />
<SubNav/>
    <div className=" p-4" style={{backgroundColor:'#C1E899'}}>
      {/* Hero Section */}
      <section className="bg-blue-800 text-amber-900 py-20">
        <div className="container mx-auto text-center">
          <h1 className="text-5xl text-gray-900 font-bold mb-4" style={{fontSize:'32px',color:'#55883B'}}>Boost Your Brand with Innovative Advertising Promotions</h1>
          <p className="text-xl text-gray-900 mb-8" style={{color:'#55883B'}}>Reach your audience through tailored marketing strategies and maximize your ROI.</p>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 p-4 gap-3">
      <h2 className="text-4xl font-bold text-left mb-12" style={{color:'#55883B'}}>Our Promotion Strategies</h2>
        <div className="w-fit gap-3 mx-auto flex p-2">
            <div className="p-6 border border-1 rounded-lg shadow-md hover:shadow-lg"  style={{backgroundColor:'#E6F0DC'}} onClick={handleDigital}>
              <FaBullhorn className="text-4xl text-blue-800 mb-4" />
              <h3 className="text-2xl text-black font-semibold mb-2">Digital Marketing</h3>
              <p className="text-black">Leverage social media, PPC, and SEO to maximize your reach.</p>
            </div>
            <div className="p-6 border border-1 rounded-lg shadow-md hover:shadow-lg" style={{backgroundColor:'#E6F0DC'}} onClick={handleInfluencer}>
              <FaUsers className="text-4xl text-blue-800 mb-4" />
              <h3 className="text-2xl font-semibold mb-2">Influencer Partnerships</h3>
              <p className="text-gray-600">Collaborate with key influencers in your industry.</p>
            </div>
            <div className=" p-6 border border-1 rounded-lg shadow-md hover:shadow-lg" style={{backgroundColor:'#E6F0DC'}} onClick={handlePaid}>
              <FaRocket className="text-4xl text-blue-800 mb-4" />
              <h3 className="text-2xl font-semibold mb-2">Paid Media</h3>
              <p className="text-gray-600">Run targeted ad campaigns on Facebook, Google, and more.</p>
            </div>
            <div className=" p-6 border border-1 rounded-lg shadow-md hover:shadow-lg" style={{backgroundColor:'#E6F0DC'}} onClick={handleEvent}>
              <FaDollarSign className="text-4xl text-blue-800 mb-4" />
              <h3 className="text-2xl font-semibold mb-2">Event Promotions</h3>
              <p className="text-gray-600">Create buzz with in-person and online events.</p>
            </div>
        </div>
      </section>

      {/* Promotional Tools Section */}
      <section className="py-16 p-4">
      <h2 className="text-4xl font-bold text-left mb-12" style={{color:'#55883B'}}>Enhance Your Campaign with Our Resources</h2>
        <div className="container mx-3 flex pt-3">
            <div className="p-6 border border-1 hover:shadow-lg rounded-lg shadow-md" style={{backgroundColor:'#E6F0DC'}} onClick={handleCalculator}>
              <FaCalculator className="text-4xl text-blue-800 mb-4" />
              <h3 className="text-2xl font-semibold mb-2">ROI Calculators</h3>
              <p className="text-gray-600">Calculate your ROI based on ad spend and performance.</p>
              <Button className="mt-4 bg-blue-600 text-white px-4 py-2 rounded-md">Try It Now</Button>
            </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="bg-blue-800 text-white py-16 p-3">
        <div className="container mx-auto text-center">
          <h2 className="text-4xl text-gray-900 font-bold mb-6">Ready to promote your work?</h2>
          <button className="bg-white text-blue-800 px-6 py-3 rounded-md font-semibold hover:bg-gray-200">
            Talk with out bot for suggestions and strategies for advertisements
          </button>
        </div>
      </section>
    </div>
    </>
    
  );
};

export default AdvertisingPromotions;

